import React, { useEffect, useState } from 'react'
import { throttle } from 'lodash'
import { ActionBar, ActionBarProps } from 'components/styled/action-bar'
import { ACTION_BAR_ROOT_ID } from 'components/styled/page/app-content'
import { connect } from 'react-redux'
import { setActionBarHeight } from 'actions'

type Props = ActionBarProps & {
  dispatch: any
  setHeight: number
  hideBeforeScroll?: boolean
}

const mapStateToProps = (state: any) => ({
  setHeight: state.global.actionBarHeight,
})

export const ActionBarWrapper = ({
  dispatch,
  setHeight,
  hideBeforeScroll = false,
  ...props
}: Props) => {
  const [currentHeight, setCurrentHeight] = useState<number | undefined>(0)
  const [hideActionBar, setHideActionBar] = useState(false)

  const updateDimensions = throttle(() => {
    const actionBarHeight =
      document.getElementById(ACTION_BAR_ROOT_ID)?.clientHeight
    setCurrentHeight(actionBarHeight)
  }, 1000)

  const setActionBarVisibility = () => {
    if (window.scrollY === 0 && hideBeforeScroll) {
      setHideActionBar(true)
    } else {
      setHideActionBar(false)
    }
  }

  useEffect(() => {
    if (window.scrollY === 0 && hideBeforeScroll) {
      setHideActionBar(true)
    }
    window.addEventListener('scroll', setActionBarVisibility)

    updateDimensions()
    window.addEventListener('resize', updateDimensions)

    return () => {
      window.removeEventListener('scroll', setActionBarVisibility)
      window.removeEventListener('resize', updateDimensions)
      dispatch(setActionBarHeight(0))
    }
  }, [])

  useEffect(() => {
    if (currentHeight !== setHeight) {
      dispatch(setActionBarHeight(currentHeight))
    }
  }, [currentHeight])

  return (
    <>
      <ActionBar {...props} hideActionBar={hideActionBar} />
    </>
  )
}

export default connect(mapStateToProps)(ActionBarWrapper)
